import { useEffect, useRef } from 'react'

const heroImage = 'https://blueberry.azureedge.net/WillMars/willmars-hero-global-v3.avif'

function Hero() {
  const sectionRef = useRef(null)
  const imageRef = useRef(null)

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const section = sectionRef.current
    const image = imageRef.current
    let ticking = false

    function update() {
      if (!reducedMotion && section && image && window.scrollY < section.offsetHeight) {
        image.style.transform = `translate3d(0, ${window.scrollY * 0.12}px, 0) scale(1.035)`
      }
      ticking = false
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update)
        ticking = true
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    update()

    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <section className="hero" ref={sectionRef}>
      <img
        className="hero-img"
        src={heroImage}
        alt="Indian reinsurance professional presenting to African and English colleagues in an international strategy discussion"
        ref={imageRef}
      />
      <div className="wrap">
        <div className="hero-content">
          <div className="eyebrow">Independent reinsurance expertise</div>
          <h1>Connecting risk with <em>global opportunity.</em></h1>
          <p>Strategic reinsurance solutions supported by African market intelligence, international access and decades of industry experience.</p>
          <div className="actions">
            <a className="btn primary" href="#capabilities">Explore Our Capabilities</a>
            <a className="btn secondary" href="#contact">Speak to Our Team</a>
          </div>
        </div>
      </div>
      <div className="hero-note">
        <strong>KE · TZ</strong>
        <span>Two distinct market teams. One internationally connected reinsurance platform.</span>
      </div>
    </section>
  )
}

export default Hero
